var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionDirectionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.98,
    height: 36.448,
    viewBox: "0 0 24.98 36.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_163",
    "data-name": "Raggruppa 163",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_160",
    "data-name": "Raggruppa 160",
    transform: "translate(4.903 4.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_159",
    "data-name": "Raggruppa 159",
    transform: "translate(13.175 18.598) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_153",
    "data-name": "Raggruppa 153",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_992",
    "data-name": "Tracciato 992",
    d: "M13.175,12.007l-.961-.961L7.267,15.994V0H5.911V16L.961,11.054,0,12.014,6.584,18.6Z",
    transform: "translate(0)",
    fill: "#272829"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1001",
    "data-name": "Tracciato 1001",
    d: "M1.355,6.558V0H0V6.561Z",
    transform: "translate(0.314 18.598) rotate(-90)",
    fill: "#272829"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_235",
    "data-name": "Rettangolo 235",
    width: 22.99,
    height: 34.463,
    transform: "matrix(-1, 0, 0, -1, 22.98, 34.449)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_225",
    "data-name": "Linea 225",
    x2: 13.423,
    transform: "translate(4.651 27.204)",
    fill: "none",
    stroke: "#ed1c24",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_226",
    "data-name": "Linea 226",
    x2: 13.423,
    transform: "translate(4.651 30.974)",
    fill: "none",
    stroke: "#ed1c24",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDirectionsIcon);
export default __webpack_public_path__ + "static/media/action-directions-icon.b843298b3c084cd9c9d87ee603fedcf5.svg";
export { ForwardRef as ReactComponent };